import React from 'react';
import { Radio as AntRadio } from 'antd';

/**
 * Wrapper component for Ant Design Radio
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Radio functionality and sub-components.
 * 
 * @component
 * @example
 * import { Radio } from '../GeneralComponents/ui';
 * 
 * // Single Radio
 * <Radio>Option A</Radio>
 * 
 * // Radio Group
 * <Radio.Group>
 *   <Radio value={1}>Option 1</Radio>
 *   <Radio value={2}>Option 2</Radio>
 * </Radio.Group>
 * 
 * @see https://ant.design/components/radio/ - Ant Design Radio documentation
 */
const Radio = (props) => {
  return <AntRadio {...props} />;
};

// Preserve Radio sub-components
Radio.Group = AntRadio.Group;
Radio.Button = AntRadio.Button;

export default Radio;

